export class VaultingInfo {
  enabled: boolean;

  constructor(info?: any) {
    info = info || {};
    this.enabled = info.enabled || null;
  }
}
